import {CheckOutlined, ClockCircleOutlined, CloseOutlined} from '@ant-design/icons';
import {TagProps} from 'antd/es/tag';
import {UserFieldsFragment, UserStatus} from 'api/generated';
import {StatusTag} from 'components/StatusTag';
import {colors} from 'lib/colors';
import React from 'react';

interface Props extends TagProps {
  user: UserFieldsFragment;
}

export const UserStatusTag: React.FC<Props> = ({user, ...props}) => {
  const getStatusTag = () => {
    if (!user.enabled)
      return (
        <StatusTag {...props} color={colors.grey}>
          Disabled <CloseOutlined />
        </StatusTag>
      );
    switch (user.status) {
      case UserStatus.RESET_REQUIRED:
        return (
          <StatusTag {...props} color={colors.grey}>
            Reset required <ClockCircleOutlined />
          </StatusTag>
        );
      case UserStatus.UNCONFIRMED:
        return (
          <StatusTag {...props} color={colors.grey}>
            Unconfirmed <ClockCircleOutlined />
          </StatusTag>
        );
      case UserStatus.FORCE_CHANGE_PASSWORD:
        return (
          <StatusTag {...props} color={colors.grey}>
            Password change required <ClockCircleOutlined />
          </StatusTag>
        );
      case UserStatus.CONFIRMED:
        return (
          <StatusTag {...props} color={colors.success}>
            Confirmed <CheckOutlined />
          </StatusTag>
        );
      default:
        return (
          <StatusTag {...props} color={colors.success}>
            {user.status}
          </StatusTag>
        );
    }
  };

  return getStatusTag();
};
